import React, { useEffect, useState, useRef } from "react";
import oembedParser from "@/utils/oembedParser";

export default function VideoTestimonial({ urlVideo }) {
  const [video, setVideo] = useState(null);
  const [showVideo, setShowVideo] = useState(false);

  let videoWrapper = useRef(null);

  useEffect(() => {
    fetchVideo(urlVideo);
  }, []);

  async function fetchVideo(url) {
    if (url) {
      const video = await oembedParser(urlVideo);
      setVideo(video);
      setShowVideo(!showVideo);
    }
  }

  // on iframe load set width and height
  useEffect(() => {
    if (video && video.html) {
      // add width and height to iframe 100% of parent
      video.html = video.html.replace(
        '<iframe',
        '<iframe width="100%" height="100%"'
      );
    }
  }, [video]);

  return (
    <div className="relative w-full h-full overflow-hidden bg-no-repeat bg-cover aspect-video auto-resizable-iframe">
      {!showVideo ? (
        <img
          src={video?.thumbnail_url}
          alt={video?.title}
          className="object-cover w-full h-full overflow-hidden transition duration-500 ease-in-out cursor-pointer hover:scale-125"
          onClick={() => setShowVideo(!showVideo)}
        />
      ) : (
        <div
          className="object-cover w-full h-full max-w-full max-h-full"
          dangerouslySetInnerHTML={{
            __html: video?.html,
          }}
          ref={videoWrapper}
        ></div>
      )}
    </div>
  );
}
